var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
export const approveHoursDialog = ({ rows, t, handleApproveHours, fetchReload, }) => {
    const volunteersWithPendingHours = rows.filter((row) => row.columns.hoursStatus === 'pending');
    const count = volunteersWithPendingHours.length;
    if (!count) {
        return;
    }
    const volunteerName = volunteersWithPendingHours[0].columns.participantFullName;
    const contentTranslationOptions = { count };
    if (rows.length !== count) {
        Object.assign(contentTranslationOptions, { context: 'manyDifferent' });
    }
    showConfirmDialog({
        title: t('shifts.adminTimeTracking.approveHoursDialog.approveTitle', { count, volunteerName }),
        content: t('shifts.adminTimeTracking.approveHoursDialog.approveContent', contentTranslationOptions),
        confirmLabel: t('shifts.adminTimeTracking.approveHours'),
        onConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
            yield handleApproveHours({ participationIds: rows.map((row) => row.id) });
            yield fetchReload();
        }),
    });
};
